export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9918.8dd7e5da.jpg";